import React, { useCallback, useEffect, useState } from "react";
import { adminApi } from "../services/adminApi";
import usePolling from "../hooks/usePolling";
import Pagination from "../components/Pagination";

export default function AuditLogs() {
  const [filters, setFilters] = useState({ action: "", userId: "" });
  const [logs, setLogs] = useState([]);
  const [paging, setPaging] = useState({ page: 1, pageSize: 10, total: 0 });
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const res = await adminApi.getLogs({
        page: paging.page,
        pageSize: paging.pageSize,
        ...filters,
      });
      setLogs(res.items || []);
      setPaging((prev) => ({ ...prev, total: res.total || 0 }));
      setError("");
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to load logs");
    }
  }, [filters, paging.page, paging.pageSize]);

  usePolling(load, 15000, [filters.action, filters.userId, paging.page, paging.pageSize]);

  useEffect(() => {
    setPaging((prev) => (prev.page === 1 ? prev : { ...prev, page: 1 }));
  }, [filters.action, filters.userId]);

  return (
    <div>
      <h2>Security & Audit Logs</h2>
      <p className="muted">Auto refresh every 15 seconds.</p>
      <div className="row" style={{ marginBottom: 10 }}>
        <input
          placeholder="Action contains..."
          value={filters.action}
          onChange={(e) => setFilters((prev) => ({ ...prev, action: e.target.value }))}
        />
        <input
          placeholder="Filter by user ID"
          value={filters.userId}
          onChange={(e) => setFilters((prev) => ({ ...prev, userId: e.target.value }))}
        />
        <button className="btn-primary" onClick={load}>
          Refresh
        </button>
      </div>
      {error ? <div className="error">{error}</div> : null}

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Actor</th>
                <th>Action</th>
                <th>Metadata</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>{new Date(log.createdAt).toLocaleString()}</td>
                  <td>{log.user?.email || "system"}</td>
                  <td>{log.action}</td>
                  <td>
                    <code>{JSON.stringify(log.meta || {})}</code>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          page={paging.page}
          pageSize={paging.pageSize}
          total={paging.total}
          onPageChange={(nextPage) =>
            setPaging((prev) => ({
              ...prev,
              page: nextPage,
            }))
          }
        />
      </div>
    </div>
  );
}
